import TokenServices from "../lib/auth-ts/services/tokenServices";
const getAccountUUID = id => id.split(':')[3]
const getPersonUUID = id => id.split(':')[2]
const getThingUUID = id => id.split(':')[3]
const isReasonToDisconnect = function({ reason }) {
    return reason === 'bondy.user.credentials_changed' || reason === 'bondy.user.deleted'
}

export default {
    getAccountUUID,
    getPersonUUID,
    getThingUUID,
    isReasonToDisconnect,
    TokenServices
}